import React from "react";

export default function DiamondTextBox({ data, containerStyle, boxStyle }) {
  return (
    <div
      className={`p-[2%_0_4%_0] flex justify-center flex-wrap gap-y-[19px] md:gap-y-[30px] gap-x-[2%] w-[85%] xs:w-full md:w-[85%] mx-auto ${containerStyle}`}
    >
      {data.map(({ imgUrl, title }, index) => {
        return (
          <div
            key={index}
            className={` text-[#373737] text-center ${
              boxStyle
                ? boxStyle
                : "w-full p-[10%] xs:w-[33.33%] md:w-[26%] xs:p-[4%] md:p-[10px] bg-white"
            }`}
          >
            <img className="mx-auto" src={imgUrl}></img>

            <h3 className="text-[18px] md:text-[20px] leading-[23px] font-bold my-[0.67em]">
              {title}
            </h3>
          </div>
        );
      })}
    </div>
  );
}
